// extracted by mini-css-extract-plugin
module.exports = {"p":"RichTextBasic_p__5gehL","li":"RichTextBasic_li__TKppj","ul":"RichTextBasic_ul__N_Rte"};